import { useEffect } from 'react';

export const SITE_URL = 'https://labpsi.mdp.edu.ar';

export const DEFAULT_DESCRIPTION =
  'LABPSI: ejercicios cognitivos y actividades de Psicología para estudiantes y para la comunidad. Laboratorio de Psicología, Facultad de Psicología, UNMdP - CONICET.';

function setMeta(selector, create) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = create();
    document.head.appendChild(el);
  }
  return el;
}

/** Título, descripción y canonical por página (el canonical apunta siempre al dominio histórico). */
export function usePageMeta(title, description = DEFAULT_DESCRIPTION) {
  useEffect(() => {
    if (title) document.title = title;

    const meta = setMeta('meta[name="description"]', () => {
      const m = document.createElement('meta');
      m.setAttribute('name', 'description');
      return m;
    });
    meta.setAttribute('content', description || DEFAULT_DESCRIPTION);

    const canonical = setMeta('link[rel="canonical"]', () => {
      const l = document.createElement('link');
      l.setAttribute('rel', 'canonical');
      return l;
    });
    canonical.setAttribute('href', `${SITE_URL}${window.location.pathname}`);
  }, [title, description]);
}
